import React from "react";
import "./sidemenu.scss";
import { SIDEMENU_ITEMS } from "@/components/constants/sidemenu-items.constants";
import { useNonInitialEffect } from "@/hooks/useNonInitialEffect";
import SideMenuItem from "./sidemenu-item/sidemenu-item";
import "react-social-icons/facebook";
import "react-social-icons/instagram";
import CustomSvg from "@/components/common/custom-svg/custom-svg";
import FbIcon from "@/assets/icons-v2/facebook.png";
import Insta from "@/assets/icons-v2/insta.png";
import clsx from "clsx";
import RedditIcon from "@/assets/icons-v2/reddit_logo.png";

interface MenuItemShape {
    label: string;
    url?: string;
    icon: React.ReactNode;
    isRegistered?: boolean;
    hidden?: boolean;
}

interface SidemenuProps {
    isOpen: boolean;
    onClose: () => void;
    onProfileToggle?: () => void;
}

const Sidemenu: React.FC<Readonly<SidemenuProps>> = (props) => {
    const menuItems: MenuItemShape[] = SIDEMENU_ITEMS as unknown as MenuItemShape[];

    /**
     * Custom React hook to add an event listener to handle clicks outside the SideMenu component.
     * The event listener will be added only when the menu is open.
     */
    useNonInitialEffect(() => {
        // Add event listener to handle clicks outside the SideMenu component
        const handleOutsideClick = (event: MouseEvent) => {
            const sideMenu = document.querySelector(".side-menu");
            const menuIcons = document.querySelector(".menu-icons");

            if (
                sideMenu &&
                menuIcons &&
                !sideMenu.contains(event.target as Node) &&
                !menuIcons.contains(event.target as Node)
            ) {
                props.onClose();
            }
        };

        if (props.isOpen) {
            document.addEventListener("click", handleOutsideClick);
        }

        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, [props.isOpen, props.onClose]);

    return (
        <div className={clsx("side-menu", props.isOpen && "open")}>
            <ul className="menu-items">
                {menuItems.map((item) => (
                    <SideMenuItem
                        key={"menu-items-" + item.label}
                        item={item}
                        onProfileToggle={props.onProfileToggle}
                        onClose={props.onClose}
                    />
                ))}
                <hr className="tw-mx-4" />
            </ul>
            <div className="follow">
                <center>Follow Us</center>
            </div>
            <div className="social-media-links">
                <center>
                    <CustomSvg
                        src={FbIcon}
                        size={{ height: 35, width: 35 }}
                        onClick={() => window.open("https://www.facebook.com/groups/pricemeapp/", "_blank")}
                    />
                    <CustomSvg
                        src={Insta}
                        size={{ height: 35, width: 35 }}
                        onClick={() => window.open("https://www.instagram.com/pricemegame/", "_blank")}
                    />
                    <CustomSvg
                        src={RedditIcon}
                        size={{ height: 35, width: 35 }}
                        onClick={() => window.open("https://www.reddit.com/r/PriceMe/", "_blank")}
                    />
                </center>
            </div>
        </div>
    );
};

export default Sidemenu;
